import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const LikeButton = ({ photo, onChange, size = "sm" }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState({ liked: photo.liked_by_me, likes: photo.likes });
  const [burst, setBurst] = useState(0);

  const toggle = async (e) => {
    e.stopPropagation();
    if (!user) {
      toast("Entre para votar nas fotos");
      nav("/entrar");
      return;
    }
    try {
      const { data } = await api.post(`/photos/${photo.id}/like`);
      setState(data);
      if (data.liked) setBurst((b) => b + 1);
      onChange?.(data);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  const big = size === "lg";
  return (
    <button
      data-testid={`photo-vote-button-${photo.id}`}
      onClick={toggle}
      className={`relative flex items-center gap-1.5 rounded-full border px-3 py-1.5 font-mono-tech text-xs transition-colors duration-200 ${
        state.liked ? "border-red-500/60 bg-red-500/15 text-red-300" : "border-white/15 bg-black/50 text-white hover:border-red-400/60"
      } ${big ? "px-5 py-2.5 text-sm" : ""}`}
    >
      <motion.span key={burst} initial={{ scale: 1 }} animate={{ scale: [1, 1.5, 1] }} transition={{ duration: 0.35 }}>
        <Heart className={`${big ? "h-5 w-5" : "h-4 w-4"} ${state.liked ? "fill-red-500 text-red-500" : ""}`} />
      </motion.span>
      <AnimatePresence mode="popLayout">
        <motion.span key={state.likes} initial={{ y: -8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 8, opacity: 0 }} data-testid={`photo-likes-count-${photo.id}`}>
          {state.likes}
        </motion.span>
      </AnimatePresence>
    </button>
  );
};
